import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-item',
  templateUrl: './no-item.component.html',
  styleUrls: ['./no-item.component.scss'],
})
export class NoItemComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
